// Generated by ts-to-zod
import { z } from 'zod';

export const urlSchema = z.string();
